module.exports = __webpack_public_path__ + "static/media/kebabMenu.9aba3cdd.svg";